import { requireStates } from "util";
import { ConnectComponent } from "util";
import View from "./list/view";
import Presenter from "./list/presenter";

const initialStates = [
  {
    name: "app.registration.category",
    url: "/categorias",
    views: {
      "content@app": ConnectComponent(View, Presenter)
    },
    data: {
      navigation: {
        priority: 0,
        name: "Categorias",
        state: "app.registration.category"
      },
      authorization: context =>
        context.user.permissions.includes("manage_category")
    }
  }
];

const context = require.context("./", true, /\.\/[^/]+\/index\.jsx?$/);
const states = requireStates(context, initialStates);

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/category/index.js